import styled from 'styled-components'

export const CardBeneficio = styled.div`
  border: 1px solid var(--cinzaClaro-riber);
  box-sizing: border-box;
  border-radius: 5px;
  padding: 20px;

  & .icon-trash {
    font-size: 24px;
    color: var(--vermelho-riber);
    cursor: pointer;
  }
`
export const ContentPerfisSelecao = styled.div`
  height: 350px;
  overflow: auto;
  border: 1px solid var(--cinzaClaro-riber);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  font-weight: 700;

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: darkgrey;
    border-radius: 15px;
  }

  &::-webkit-scrollbar-corner {
    background-color: transparent;
  }

  &::-webkit-scrollbar-track {
    margin: 2px 10px;
  }

  & .itens-lista {
    color: #5e5e5e;
    cursor: pointer;
    padding: 10px 5px;

    &:hover {
      background-color: var(--cinzaClaro-riber);
    }
  }

  & li {
    list-style-type: none;
  }
`
export const AlinhamentoBeneficio = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 18px;
  & > * {
    flex: 1;
  }
`
interface SimpleTitleCardMeusDadosProps {
  color?: string
  colorIcon?: string
}
export const SimpleTitleCardMeusDados = styled.div<SimpleTitleCardMeusDadosProps>`
  align-items: center;
  color: ${(props) => (props.color ? `${props.color}` : 'var(--dark-gray)')};
  display: flex;
  flex-direction: row;
  font-family: 'Open Sans', serif;
  font-size: 18px !important;
  font-weight: 700;
  gap: 10px;
  margin-left: 12px;
  justify-content: left;
  padding-bottom: 20px;
  & .icon {
    color: ${(props) =>
      props.colorIcon ? `#${props.colorIcon}` : 'var(--verde-riber)'};
    width: 25px;
    height: 25px;
  }
`
